<template>
    <div class="registration-form">
        <b-modal
            id="registration-modal"
            ref="registration-modal"
            :title="title"
            centered
            size="lg"
            :title-class="['h2','text-secondary']"
            header-bg-variant="primary"
            header-text-variant="secondary"
            cancel-title = "Cancelar"
            @hidden="hiddenModal"
            no-close-on-backdrop
            :no-enforce-focus="true"
            >
              <b-form ref="registrationForm" @submit.stop.prevent>
                <fieldset :disabled="formDisabled">
                  <b-form-row>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="emailError?false:true"
                        label-for="email"
                        label-class="text-left"
                        :invalid-feedback="emailError"
                        label="Email"
                      >
                        <b-form-input
                          trim
                          aria-label="Email"
                          id="email"
                          placeholder="Email"
                          v-model="thing.email"
                          :state="emailError?false:true"
                          @change="errors = []"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="nameError?false:true"
                        label-for="name"
                        label="Nombre"
                        label-class="text-left"
                        :invalid-feedback="nameError"
                      >
                        <b-form-input
                          trim
                          aria-label="Name"
                          id="name"
                          v-model="thing.name"
                          placeholder="Nombre(s)"
                          :state="nameError?false:true"
                          :disabled="thing.license_is_valid"
                          @change="errors = []"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="last_nameError?false:true"
                        label-for="last_name"
                        label-class="text-left"
                        :invalid-feedback="last_nameError"
                        label="Apellido Paterno"
                      >
                        <b-form-input
                          trim
                          type="text"
                          aria-label="Apellido Paterno"
                          id="last_name"
                          v-model="thing.last_name"
                          placeholder="Apellido Paterno"
                          :state="last_nameError?false:true"
                          :disabled="thing.license_is_valid"
                          @change="errors = []"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="mother_last_nameError?false:true"
                        label-for="mother_last_name"
                        label="Apellido Materno"
                        label-class="text-left"
                        :invalid-feedback="mother_last_nameError"
                      >
                        <b-form-input
                          trim
                          type="text"
                          aria-label="Apellido Materno"
                          id="mother_last_name"
                          v-model="thing.mother_last_name"
                          placeholder="Apellido Materno"
                          :state="mother_last_nameError?false:true"
                          :disabled="thing.license_is_valid"
                          @change="errors = []"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                      <b-form-group
                          :state="licenseError?false:true"
                          label-for="license"
                          label="Cédula Profesional*"
                          label-class="text-left"
                          :invalid-feedback="licenseError"
                      >
                        <b-input-group>
                          <b-form-input
                              trim
                              aria-label="license"
                              id="license"
                              v-model="thing.license"
                              placeholder="Cédula Profesional"
                              :state="licenseError?false:true"
                              @change="licenseChange"
                              :disabled="thing.license_is_valid"
                          ></b-form-input>
                          <b-input-group-append>
                              <b-button size="md" variant="danger" :disabled="!thing.license_is_valid" @click="resetLicense">
                                  <b-icon variant="light" icon="trash-fill"></b-icon>
                              </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      <h6>{{thing.specialty}}</h6>
                    </b-col>
<!--                    <b-col sm="12" md="6">
                      <ComboSelect 
                        @selected="specialtySelected" 
                        :data="{default_value: thing.company, label: 'Especialidad', options: specialty_options}"
                      />
                    </b-col>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="phoneError?false:true"
                        label="Teléfono a 10 dígitos"
                        label-for="phone"
                        label-class="text-left"
                        :invalid-feedback="phoneError"
                      >
                        <b-form-input
                          trim
                          type="text"
                          aria-label="Teléfono a 10 dígitos"
                          id="phone"
                          v-model="thing.phone"
                          placeholder="Teléfono"
                          :state="phoneError?false:true"
                          @change="errors = []"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>  -->
<!--                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="cityError?false:true"
                        label-for="city"
                        label-class="text-left"
                        :invalid-feedback="cityError"
                      >
                        <b-form-input
                          trim
                          type="text"
                          aria-label="Ciudad"
                          id="city"
                          v-model="thing.city"
                          placeholder="Ciudad"
                          :state="cityError?false:true"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col> -->
<!-- 
                      <b-form-group
                        :state="companyError?false:true"
                        label-for="company"
                        label-class="text-left"
                        :invalid-feedback="companyError"
                      >
                        <b-form-input
                          trim
                          type="text"
                          aria-label="Empresa"
                          id="company"
                          v-model="thing.company"
                          placeholder="Empresa"
                          :state="companyError?false:true"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :state="positionError?false:true"
                        label-for="position"
                        label-class="text-left"
                        :invalid-feedback="positionError"
                      >
                        <b-form-input
                          trim
                          type="text"
                          aria-label="Cargo"
                          id="position"
                          v-model="thing.position"
                          placeholder="Cargo"
                          :state="positionError?false:true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col> -->
                    <b-col sm="12" md="6" v-if="$store.getters.isModuleActive('Selector de Modalidad')">
                      <b-form-group 
                          label="Modalidad de Asistencia"
                      >
                          <b-form-select
                              v-model="thing.modality"
                              :options="variable_lov" 
                              :value="thing.modality"
                              value-field="value"
                              text-field="text"
                              id="modality"
                              name="modality"
                            >
                          </b-form-select>
                      </b-form-group>
                  </b-col>
                  <b-col cols="12" v-if="$store.getters.isModuleActive('Selector de Modalidad')">
                    <p class="text-justify"><small>** Los lugares para asistencia presencial están sujetos a disponibilidad. Le contactarán al correo electrónico y/o teléfono que registre para confirmar su asistencia.</small></p>
                  </b-col>
                  </b-form-row>
                </fieldset>
              </b-form>
              <template v-slot:modal-footer>
                <b-button-group class="float-right" size="md">
                  <b-button v-if="!formDisabled" :disabled="!isValid" @click="onSubmit" variant="success">
                    {{btnTitle}}
                  </b-button>
                </b-button-group>
              </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import ComboSelect from '@/components/Widget/ComboSelect/ComboSelect.vue'

export default Vue.extend({
    name: 'RegistrationForm',
    components: {
      ComboSelect,
    },
    props: {
      eventKeyId: { type: String, default: null },
      email: { type: String, default: null },
      preliminary_data: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        thing: {
          email: null,
          id: null,
          url: null,
          name: null,
          phone: null,
          city: null,
          specialty: null,
          last_name: null,
          mother_last_name: null,
          event__url_to: null,
          event__name: null,
          event__start_date: null,
          key_id: null,
          event_key_id: this.eventKeyId,
          join_url: null,
          license: null,
          gender: null,
          school: null,
          company: 'Medicina General y Práctica General',
          position: null,
          confirmed: false,
          license_is_valid: false,
          browser_info: this.$browserDetect.meta.ua,
          modality: 'Presencial'
        },
        formDisabled: false,
        errors: [],
        variable_lov: [
          { value: 'Virtual', text: 'Virtual' },
          { value: 'Presencial', text: 'Presencial' },
        ],
        specialty_options: [
          { value: "Accidente y Emergencia",text: "Accidente y Emergencia"},
          { value: "Alergología",text: "Alergología"},
          { value: "Anestesia y UTI",text: "Anestesia y UTI"},
          { value: "Cardiología",text: "Cardiología"},
          { value: "Cardiología Intervensionista",text: "Cardiología Intervensionista"},
          { value: "Cirugía",text: "Cirugía"},
          { value: "Cirugía - Gastroenterología",text: "Cirugía - Gastroenterología"},
          { value: "Cirugía - Senos",text: "Cirugía - Senos"},
          { value: "Cirugía - Urológica",text: "Cirugía - Urológica"},
          { value: "Cirugía Cardiotorácica",text: "Cirugía Cardiotorácica"},
          { value: "Cirugía Plástica",text: "Cirugía Plástica"},
          { value: "Comité de Drogas",text: "Comité de Drogas"},
          { value: "Dermatología",text: "Dermatología"},
          { value: "Endocrinología y Diabetes",text: "Endocrinología y Diabetes"},
          { value: "Enfermedades Infecciosas y Medicina Tropical",text: "Enfermedades Infecciosas y Medicina Tropical"},
          { value: "Enfermería",text: "Enfermería"},
          { value: "Especialidad Desconocida",text: "Especialidad Desconocida"},
          { value: "Especialidades Paramédicas",text: "Especialidades Paramédicas"},
          { value: "Farmacología y Toxicología",text: "Farmacología y Toxicología"},
          { value: "Fisiología Clínica",text: "Fisiología Clínica"},
          { value: "Fisioterapia",text: "Fisioterapia"},
          { value: "Forense",text: "Forense"},
          { value: "Gastroenterología",text: "Gastroenterología"},
          { value: "Genética",text: "Genética"},
          { value: "Geriatría y Gerontología",text: "Geriatría y Gerontología"},
          { value: "Hematología",text: "Hematología"},
          { value: "Hematología Pediátrica",text: "Hematología Pediátrica"},
          { value: "Inmunología e Inmunopatología",text: "Inmunología e Inmunopatología"},
          { value: "Manejo del Dolor",text: "Manejo del Dolor"},
          { value: "Medicina Complementaria y Alternativa",text: "Medicina Complementaria y Alternativa"},
          { value: "Medicina Familiar",text: "Medicina Familiar"},
          { value: "Medicina General y Práctica General",text: "Medicina General y Práctica General"},
          { value: "Medicina Genitourinaria",text: "Medicina Genitourinaria"},
          { value: "Medicina Interna",text: "Medicina Interna"},
          { value: "Medicina Oral y Cirugía Maxilofacial",text: "Medicina Oral y Cirugía Maxilofacial"},
          { value: "Medicina Paliativa",text: "Medicina Paliativa"},
          { value: "Nefrología y Renal",text: "Nefrología y Renal"},
          { value: "Neroloía y Neurociencia",text: "Neroloía y Neurociencia"},
          { value: "Neumología",text: "Neumología"},
          { value: "Neumología pediátrica",text: "Neumología pediátrica"},
          { value: "Neurocirugía",text: "Neurocirugía"},
          { value: "Nutrición y Dietética",text: "Nutrición y Dietética"},
          { value: "Obstetrícia y Ginecología",text: "Obstetrícia y Ginecología"},
          { value: "Oftalmología",text: "Oftalmología"},
          { value: "Oncología",text: "Oncología"},
          { value: "Oncología Ginecológica",text: "Oncología Ginecológica"},
          { value: "Oncología Pediátrica",text: "Oncología Pediátrica"},
          { value: "Oncología Quirúrgica",text: "Oncología Quirúrgica"},
          { value: "Oncología y Cáncer de Mama",text: "Oncología y Cáncer de Mama"},
          { value: "Oncología y Cáncer de Pulmón",text: "Oncología y Cáncer de Pulmón"},
          { value: "Oncología y Gastroenterología",text: "Oncología y Gastroenterología"},
          { value: "Oncología y Neuro",text: "Oncología y Neuro"},
          { value: "Oncología y Respiratorio",text: "Oncología y Respiratorio"},
          { value: "Oncología y Urología",text: "Oncología y Urología"},
          { value: "Otorrinolaringología",text: "Otorrinolaringología"},
          { value: "Otras Especialidades",text: "Otras Especialidades"},
          { value: "Partería",text: "Partería"},
          { value: "Patología",text: "Patología"},
          { value: "Pediatría",text: "Pediatría"},
          { value: "Planificación Familiar y Medicina Reproductiva",text: "Planificación Familiar y Medicina Reproductiva"},
          { value: "Radiología",text: "Radiología"},
          { value: "Rehabilitación y Fisioterapia",text: "Rehabilitación y Fisioterapia"},
          { value: "Reumatología",text: "Reumatología"},
          { value: "Salud Mental y Discapacidad de Aprendizaje",text: "Salud Mental y Discapacidad de Aprendizaje"},
          { value: "Salud Pública y Medicina Comunitaria",text: "Salud Pública y Medicina Comunitaria"},
          { value: "Torácico y Respitatorio",text: "Torácico y Respitatorio"},
          { value: "Trauma y Ortopedia",text: "Trauma y Ortopedia"},
          { value: "Urología",text: "Urología"}
        ]
      }
    },
    methods: {
      specialtySelected(value) {
        this.thing.company=value
      },
      licenseChange(value) {
        let loader = this.$loading.show()
        this.errors = []
        this.form_disabled = true
        this.$store.dispatch(
            'post', 
            {
                url:'/catalog/messenger_services/get_license_data', 
                data: {
                    event_key_id : this.thing.event_key_id,
                    license: value
                }, 
                headers:{}
            }
        )
        .then((resp) => {
            loader.hide()
            this.form_disabled = false
            if(resp.data.name)
              this.$nextTick(() => {
                this.thing.license = resp.data.license
                this.thing.name = resp.data.name
                this.thing.last_name = resp.data.last_name
                this.thing.mother_last_name = resp.data.mother_last_name
                this.thing.specialty = resp.data.specialty
                this.thing.gender = resp.data.gender
                this.thing.school = resp.data.school
                if(resp.data.license_is_valid === 1) this.thing.license_is_valid = true
              })
            
        })
        .catch(err => {
            loader.hide()
            this.form_disabled = false
            this.errors = err.errors
        })
      },
      resetLicense() {
        this.thing.name = null
        this.thing.last_name = null
        this.thing.mother_last_name = null
        this.thing.specialty = null
        this.thing.license = null
        this.thing.license_is_valid = false
      },
      showModal() {
        this.$bvModal.show('registration-modal')
      },
      hiddenModal(msg) {
        if(msg) this.$emit('closed', msg)
        else this.$emit('closed')
      },
      onSubmit() {
        let loader = this.$loading.show()
        this.errors = []
        this.formDisabled = true
        let url = '/assistants/check_in'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: this.thing, headers:{}})
          .then((resp) => {
            loader.hide()
            
            if(typeof(resp.data) == 'string') {
              this.$nextTick(() => {
                this.hiddenModal(
                  {
                    title: 'Gracias por su registro',
                    text: 'Le hemos enviado las instrucciones a su correo para completar su registro.'
                  }
                )
              })
            } else {  
              let active_word_clouds = resp.data.active_word_clouds
              active_word_clouds.forEach(element => {
                  if(element.json_options) element.json_options = JSON.parse(element.json_options)
              });
              this.thing = resp.data
              this.$store.commit(
                'auth_success', 
                {
                  'token': this.thing.key_id,
                  'assistant': {
                    'name': this.thing.name + ' ' + this.thing.last_name + ' ' + this.thing.mother_last_name,
                    'email': this.thing.email,
                    'nickname': this.thing.nickname,
                    'id': this.thing.id,
                    'key_id': this.thing.key_id,
                    'remaining_attempts': this.thing.remaining_attempts,
                    'exam_approved': this.thing.exam_approved,
                    'answered_survey': this.thing.answered_survey,
                    'session_id': this.thing.session_id,
                    'join_url': this.thing.join_url,
                    //'active_word_clouds':active_word_clouds
                  },
                  'email': this.thing.email,
                  'remember_me': true
                }
              )
              /* this.$gtag.event('assistant_login', {
                'event_category': 'login',
                'event_label': 'Autenticarse',
              }) */
              
              this.$nextTick(() => {
                this.$store.commit('set_data_poll', resp.data.poll_data)
                this.$store.commit('set_data_rating', resp.data.pending_ratings)
                this.$store.commit('set_data_word_cloud', active_word_clouds)

                this.hiddenModal(
                  {
                    title: 'Registro Exitoso',
                    text: 'Se ha registrado correctamente'
                  }
                )
              })
            }
          })
          .catch(err => {
            this.formDisabled = false
            loader.hide()
            this.formDisabled = false
            this.errors = err.errors
            if(err.error) alert(err.error)
          })
      },
    },
    beforeMount() {
      this.thing.email = this.preliminary_data.email
      this.thing.name = this.preliminary_data.name
      this.thing.last_name = this.preliminary_data.last_name
      this.thing.mother_last_name = this.preliminary_data.mother_last_name
      this.thing.specialty = this.preliminary_data.specialty
      this.thing.gender = this.preliminary_data.gender
      this.thing.school = this.preliminary_data.school
      if(this.preliminary_data.license_is_valid === 1) {
        this.thing.license_is_valid = true
        this.thing.license = this.preliminary_data.license
      }
    },
    mounted() {
      this.showModal()
    },
    computed: {
      title: function() {
        return 'Registrarme'
      },
      btnTitle: function() {
        return 'Registrar'
      },
      extra: function() {
        return this.event.description
      },
      emailError: function () {
        if(this.errors && this.errors.email) return this.errors.email[0]
        return null
      },
      isValid: function() {
        if(this.last_nameError) return false
        return true
      },
      specialtyError: function () {
        if(this.errors && this.errors.specialty) return this.errors.specialty[0]
        return null
      },
      last_nameError: function () {
        if(!this.thing.last_name || (this.thing.last_name.trim().length< 1) ) return 'Digíte su Apellido Paterno'
        if(this.errors && this.errors.last_name) return this.errors.last_name[0]
        return null
      },
      mother_last_nameError: function () {
        if(!this.thing.mother_last_name || (this.thing.mother_last_name.trim().length< 1) ) return 'Digíte su Apellido Materno'
        if(this.errors && this.errors.mother_last_name) return this.errors.mother_last_name[0]
        return null
      },
      nameError: function () {
        if(this.errors && this.errors.name) return this.errors.name[0]
        return null
      },
      cityError: function () {
        if(!this.thing.city || (this.thing.city.trim().length< 1) ) return 'Digíte la Ciudad desde donde nos Visita'
        if(this.errors && this.errors.city) return this.errors.city[0]
        return null
      },
      positionError: function () {
        if(this.errors && this.errors.position) return this.errors.position[0]
        return null
      },
      companyError: function () {
        if(!this.thing.company || (this.thing.company.trim().length< 1) ) return 'Digíte la Empresa donde labora'
        if(this.errors && this.errors.company) return this.errors.company[0]
        return null
      },
      licenseError: function () {
        if(this.errors && this.errors.license) return this.errors.license[0]
        return null
      },
      phoneError: function () {
        if(this.errors && this.errors.phone) return this.errors.phone[0]
        return null
      },
    },
})
</script>

<style lang="scss" scoped>
  @import '../../styles/app';

</style>
